import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import { Container } from "react-bootstrap";
import { ButtonStandard, HeaderActions, ToastMessage } from "../../components";
import "./PreSchedulingList.scss"
import messages from "../../assets/i18n";
import ItemList from '../../containers/ItemList/ItemList'

function PreSchedulingList(props) {

	const dispatch = useDispatch();
    const history = useHistory();

	const lang = useSelector(state => state.language.name);

    const providerPreScheduling      = useSelector(state => state.provider.providerIdPreScheduling);
	const providerPreSchedulingList  = useSelector(state => state.preScheduling.preSchedulingList);
    const isLoadingPreSchedulingList = useSelector(state => state.preScheduling.isLoadingPreSchedulingList);
    const selectedPreScheduling      = useSelector(state => state.preScheduling.selectedPreScheduling);

    const [isTableEmpty, setIsTableEmpty] = useState(false)
    
	const pageMessages = messages[lang].preSchedulingListPage;
	const titleTable   = messages[lang].preSchedulingListPage.table + " " + providerPreScheduling.data.nome;
    const titlePage    = messages[lang].preSchedulingListPage.inquiry;

    const preSchedulingToast = useSelector(state => state.preScheduling.preSchedulingToast);

    const [showToast,    setShowToast]    = useState(false);
    const [messageError, setMessageError] = useState('');
    const [messageType,  setMessageType]  = useState('toast-success');

	const header = [
		pageMessages.descricao,
        pageMessages.ativo,
		pageMessages.capacidade,
        pageMessages.empresa,
        pageMessages.cd,
        ""
	];

    const pageBack = () => {
		props.history.push(`/provider-list`);
    };

    useEffect(() => {
        dispatch({
            type: 'UNSET_PROVIDER_PRE_SCHEDULING',
            payload: {
                id: null,
                data: providerPreScheduling.data
            }
        })

        dispatch({
			type: 'GET_PROVIDER_PRE_SCHEDULING_LIST',
            payload: {
                providerId: providerPreScheduling.data.id
            }
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {	
        setShowToast(preSchedulingToast.showToast)
        setMessageError(preSchedulingToast.message)
        setMessageType(preSchedulingToast.messageType)
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [preSchedulingToast]);

    useEffect(() => {
		if (selectedPreScheduling.id) {
			history.push('/pre-scheduling-details')
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedPreScheduling]);

    useEffect(() => {
		if (providerPreSchedulingList.length > 0) {
			setIsTableEmpty(false)
		} else {
            setIsTableEmpty(true)
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [providerPreSchedulingList]);

	const mappedPreSchedulingList = () => {
		return providerPreSchedulingList.map((item) => {
			return [
                    {
                        text: item.descricao,
                        maxLength: 4000
                    },
                    item.ativo,
                    item.capacidade,
                    item.empresa ? item.empresa.nome : '',
                    item.cd ? item.cd.nome : '',
                    {
						text: <i className="icon-pen" />,
                        onClick: () => {
							dispatch({
								type: 'SET_SELECTED_PRE_SCHEDULING',
								payload: {
                                    id: item.id,
                                    data: item
                                }
							})
						},
					}
				]

		});
	}

	return (
		<div className="pre-scheduling-list-page">
            <ToastMessage 
                show={showToast} 
                setShow={setShowToast}
                message={messageError} 
                toastClass={messageType} />
            <HeaderActions
                pageBack={pageBack}
                titlePage={titlePage}
			/>

            {
                providerPreScheduling.data.id
                ?
                <div>
                    <Container className="pt-4 px-4 d-flex justify-content-end">
                    <ButtonStandard
                        text={pageMessages.newPreScheduling}
                        textClass="text-1"
                        className="btn-sm btn-outline-success btn-standard px-2 mr-2"
                        onClick={() => history.push('/pre-scheduling-details')}/>
                    </Container>

                    <Container className="pt-3 justify-content-start">
                        <Container className="mt-1 pt-1 mb-4 pb-5">
                            <ItemList
                                header={header}
                                titleTable={titleTable}
                                listTable={mappedPreSchedulingList()}
                                isLoading={isLoadingPreSchedulingList}
                                isEmpty={isTableEmpty}
                                />
                        </Container>
                    </Container>   
                </div>
                :
                null
            }
         
		</div>
	)
}

export default withRouter(PreSchedulingList);